<style scope lang="scss">
  .exp_progress {
    color: #000;
    height: auto;
    .progress {
      width:100%;
      height: auto;
      border-top:1px solid #000;
      border-left:1px solid #000;
      box-sizing: border-box;
      .code {
        float: left;
        width: 132px;
        height:132px;
        margin-right: 12px;
        img {
          margin:0 0 0 2px;
          width: 100%;
          height: 100%;
        }
      }
      .info {
        margin-top: 10px;
        float: left;
        width: 280px;
        color: #000;
        dt {
          font-size: 22px;
        }
        dd {
          color: #999;
          line-height:1.6;
        }
      }
      .logo {
        float:right;
        width:250px;
        height: 130px;
      }
      .waybill {
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size:30px;
        font-weight:bold;
        color: #000;
        letter-spacing: 8px;
      }
      td {
        border-bottom:1px solid #000;
        border-right:1px solid #000;
        font-size: 12px;
        .content {
          font-size: 18px;
          color: #000;
        }
        .address {
          line-height: 1.8;
        }
        .product {
          color: #000;
          line-height: 1.6;
          padding: 6px 0;
          font-size: 13px;
          span {
            display: inline-block;
            margin: 0 8px 0 0;
          }
        }
        .case {
          padding-top:5px;
          font-size:30px;
          color: #000;
          text-align: center;
        }
      }
      td.padding {
        padding: 6px;
      }
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 5px;
    }
    .images {
      height: 136px;
      border-bottom:1px solid #000;
    }
  }
  .exp_images {
    text-align: center;
    img {
      max-width: 100%;
    }
  }
  .clearb {
    clear:both;
  }
</style>
<template>
  <div class="exp_progress">
    <table class="progress" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td colspan="4" height="136">
          <div class="code">
            <img v-if="expItems.codeSrc" :src="expItems.codeSrc" />
          </div>
          <dl class="info">
            <dt>{{expItems.expressTypeDesc}}</dt>
            <dd>微信识别二维码上传身份证、查询快递进度</dd>
          </dl>
          <div class="logo">
            <img v-if="expItems.expressType === 1" src="@/assets/frontend/images/rk_express.jpg" />
            <img v-if="expItems.expressType === 2" src="@/assets/frontend/images/giant_express.jpg" />
            <img v-if="expItems.expressType === 3" src="@/assets/frontend/images/au_express.jpg" />
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4" height="80">
          <div class="waybill">
            {{expItems.expressNo}}
            <el-button v-if="expItems.status > 3" size="mini" type="primary" plain @click="showExpImages()">查看包裹图片</el-button>
          </div>
        </td>
      </tr>
      <tr>
        <td width="25%" colspan="2" height="30" valign="bottom" class="padding">
          寄件日期:
          <span class="content">{{expItems.auCreationTime}}</span>
        </td>
        <td width="25%" valign="bottom" class="padding">
          收件人:
          <span class="content">{{expItems.addressee && expItems.addressee.name}}</span>
        </td>
        <td width="25%" valign="bottom" class="padding">
          手机:
          <span class="content">{{expItems.addressee && expItems.addressee.tel}}</span>
        </td>
      </tr>
      <tr>
        <td width="25%" height="30" valign="bottom" class="padding">
          寄件人:
          <span class="content">{{expItems.consignor && expItems.consignor.name}}</span>
        </td>
        <td width="25%" valign="bottom" class="padding">
          电话:
          <span class="content">{{expItems.consignor && expItems.consignor.tel}}</span>
        </td>
        <td rowspan="2" colspan="2" valign="top" class="padding">
          收件人地址:
          <span class="content address">{{expItems.fullAddress}}</span>
        </td>
      </tr>
      <tr>
        <td width="25%" colspan="2" height="60" valign="top" class="padding">
          地址:
          <span class="content address"></span>
        </td>
      </tr>
      <tr>
        <td width="25%" colspan="3" height="120" valign="top" class="padding">
          产品清单:
          <div class="product">
            <span v-for="item in expItems.items">{{item.productName}} x{{item.quantity}}</span>
          </div>
        </td>
        <td width="25%" valign="top" class="padding">
          箱号:
          <div class="case">{{expItems.id}}</div>
        </td>
      </tr>
    </table>
    <el-dialog title="" :visible.sync="isShowExpImages" width="650px"
        custom-class="exp_images" :before-close="closeExpImages" top="5vh" :modal="false">
        <template v-if="expItems && expItems.images && expItems.images.length > 0">
          <a v-for="(img, index) in expItems.images" :key="index" :href="img" target="_blank">
              <img :src="img" />
          </a>
        </template>
        <div v-else style="height: 250px; line-height: 250px;">暂无打包图片~</div>
    </el-dialog>
  </div>
</template>

<script>
  import areaData from '@/js/area.js'
  export default {
    name: 'expProgress',
    props: {
      'expProgressId': {
        default: 0,
        type: Number
      }
    },
    data() {
      return {
        expItems: {},
        isShowExpImages: false
      }
    },
    watch: {
      expProgressId(val) {
        console.log(this.expProgressId);
        this.getExpDetail();
      }
    },
    async mounted() {
      await areaData.getAreasData()
      this.getExpDetail();
    },
    methods: {
      getExpDetail() {
        this.$axios.get(window.consts.apis.getParcelById + "?Id=" + this.expProgressId).then(res => {
          if (res.success) {
            let item = res.result;
            this.expItems = item;
            this.expItems.fullAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ") + " " + item.addressee.detail;
            //this.getExpQRCode();
            this.expItems.codeSrc = window.baseUrl + window.consts.apis.getExpQRCode + "?ver=" + Math.random() + "&parcelId=" + this.expProgressId
          } else {
            this.$alert(res.error.message);
            return false;
          }
        }).catch(e => {
          this.$alert("获取邮单失败!");
          return false;
        });
      },
      getExpQRCode() {
        this.$axios.get(window.consts.apis.getExpQRCode + "?parcelId=" + this.expProgressId).then(res => {
          if (res.success) {
            
          } else {
            this.$alert(res.error.message);
            return false;
          }
        }).catch(e => {
          this.$alert("获取二维码失败，请刷新页面后再试!");
          return false;
        });
      },
      showExpImages() {
        this.isShowExpImages = true
      },
      closeExpImages() {
        this.isShowExpImages = false
      }
    }
  }
</script>